<template>
  <!-- Outer div for consistent responsive padding -->
  <div class="p-4 sm:p-6 md:p-8"> 
    <!-- Inner div for content width and centering (using max-w-7xl as a standard) -->
    <div class="max-w-7xl mx-auto"> 
  <div class="register-container">
    <h2>Register</h2>
    <form @submit.prevent="handleRegister">
      <div class="form-group">
        <label for="email">Email:</label>
        <input type="email" id="email" v-model="email" required />
      </div>
      <div class="form-group">
        <label for="password">Password:</label>
        <input type="password" id="password" v-model="password" required />
        <p class="password-hint">Password should be at least 6 characters.</p>
      </div>
      <!-- Optional: Confirm Password field -->
      <!--
      <div class="form-group">
        <label for="confirmPassword">Confirm Password:</label>
        <input type="password" id="confirmPassword" v-model="confirmPassword" required />
      </div>
      -->
      <button type="submit">Register</button>
      <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
      <p v-if="successMessage" class="success-message">{{ successMessage }}</p>
    </form>
    <p>
      Already have an account? <router-link to="/login">Login here</router-link>
    </p>
  </div>
    </div> <!-- Closes max-w-10xl -->
  </div>   <!-- Closes p-4 sm:p-6 md:p-8 -->
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { auth } from '@/firebaseConfig'; // Using @ to refer to src directory
import { createUserWithEmailAndPassword } from 'firebase/auth';
// Optional: to update profile later, like display name
// import { updateProfile } from 'firebase/auth';

const email = ref('');
const password = ref('');
// const confirmPassword = ref(''); // Uncomment if using confirm password
const errorMessage = ref('');
const successMessage = ref('');
const router = useRouter();

const handleRegister = async () => {
  errorMessage.value = '';
  successMessage.value = '';

  // Optional: Basic password confirmation check
  /*
  if (password.value !== confirmPassword.value) {
    errorMessage.value = 'Passwords do not match.';
    return;
  }
  */

  if (password.value.length < 6) {
    errorMessage.value = 'Password should be at least 6 characters long.';
    return;
  }

try {
  const userCredential = await createUserWithEmailAndPassword(auth, email.value, password.value);
  console.log("User registered:", userCredential.user);
    successMessage.value = 'Registration successful! Redirecting to dashboard...'; // Update message
  setTimeout(() => {
      router.push('/dashboard'); // Redirect to the dashboard
  }, 2000); // Keep the 2-second delay if you like
} catch (error) {
    console.error("Registration error:", error);
    switch (error.code) {
      case 'auth/email-already-in-use':
        errorMessage.value = 'This email address is already in use.';
        break;
      case 'auth/invalid-email':
        errorMessage.value = 'Invalid email address format.';
        break;
      case 'auth/weak-password':
        errorMessage.value = 'Password is too weak. It should be at least 6 characters.';
        break;
      default:
        errorMessage.value = 'An unexpected error occurred during registration. Please try again.';
        break;
    }
  }
};
</script>

<style scoped>
.register-container {
  max-width: 400px;
  margin: 50px auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.form-group {
  margin-bottom: 15px;
}
.form-group label {
  display: block;
  margin-bottom: 5px;
}
.form-group input {
  width: calc(100% - 12px); /* Account for padding */
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
}
.password-hint {
  font-size: 0.8em;
  color: #777;
  margin-top: 3px;
}
button {
  padding: 10px 15px;
  background-color: #007bff; /* Use your theme color */
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
button:hover {
  background-color: #0056b3; /* Darker shade of your theme color */
}
.error-message {
  color: red;
  margin-top: 10px;
}
.success-message {
  color: green;
  margin-top: 10px;
}
p {
  margin-top: 15px;
}
</style>